import script from "./social.vue?vue&type=script&setup=true&lang=js"
export * from "./social.vue?vue&type=script&setup=true&lang=js"

import "./social.vue?vue&type=style&index=0&id=179ef1b2&lang=less"

import exportComponent from "/data/jenkins/workspace/www.7pa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179ef1b2"]])

export default __exports__